const registrationTutorial = {
  module: 'registration',
  moduleName: 'Registration',
  steps: [
    { target: '.reg-header', position: 'bottom', title: 'Registration', description: 'Manage person registrations for access control and facial recognition.' },
    { target: '.reg-tabs', position: 'bottom', title: 'Tabs', description: 'Switch between registered people, pending requests, and groups.' },
    { target: '.reg-btn', position: 'bottom', title: 'Export', description: 'Download the registration list as CSV.' },
  ],
};
export default registrationTutorial;
